import { createFileRoute } from '@tanstack/react-router';

import PushMessages from '@@containers/metadata/components/Push/PushMessages';

export const Route = createFileRoute('/_authenticated/externalContent/embeds/$id/push')({
    component: PushMessages,
});
